<template lang="pug">
#customer-list
    .customer-search
        input.g-search.black(
            v-model="searchQuery"
            type="search"
            placeholder="Search..."
        )
    .card-container.scroll-y
        .wrapper(
            v-for="customer in filteredCustomers"
            :key="customer.$id"
            :class="{active: selectedUser?.$id === customer.$id}"
            @click="$emit('update:selectedUser', customer)"
        )
            .customer
                .name
                    template(v-if="(typeof customer.name === 'string')") {{ customer.name }}
                    template(v-else) {{customer.name.firstName}} {{customer.name.lastName}}
                .contact
                    .phone {{customer.phone}}
                    .email {{customer.email}}
    .button-container
        button.secondary.icon(@click="$emit('create-customer')") Create New User
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { DataInstance } from '@busy-human/gearbox';
import { Userspaces } from '@busy-human/k9-library';

type Props = {
	slots: DataInstance<Userspaces.Model>[]
	selectedUser?: DataInstance<Userspaces.Model> | undefined
}
const props = defineProps<Props>();

type Emits = {
	(e: "update:selectedUser", slot: DataInstance<Userspaces.Model>): void
	(e: 'create-customer'):void
}

defineEmits<Emits>();
const searchQuery = ref('');

//Change back to user.name.fullName onces its no longer an empty string
const filteredCustomers = computed<DataInstance<Userspaces.Model>[]>(() => props.slots.filter(user => {
	if(searchQuery.value) {
		const lowerQuery = searchQuery.value.toLowerCase();
		let searchFound = false;
		//Check Name (Can change to just user.name.full name later on)
		if(`${user.name.firstName.toLowerCase()} ${user.name.lastName.toLowerCase()}`.includes(lowerQuery))
		{searchFound = true;}
		//Check Email
		if(user.email.toLowerCase().includes(lowerQuery))
		{searchFound = true;};
		return searchFound;
	}
	return true;
}));
</script>

<style lang="scss">
#customer-list{
    position: relative;
    display:flex;
    flex-direction: column;
    gap: .5rem;
    height: 100%;
    padding-inline: 1rem;
    overflow-x: hidden;

    .customer-search,
    .customer-search input,
    .card-container ,
    .card-container .wrapper,
    .customer,
    .customer .contact,
    .button-container{
        width: 100%;
    }

    .customer-search{
        box-sizing: border-box;
        padding: 2rem;
        border-bottom: 3px solid $color-red;
    }

    .customer-search input{
        color: $color-black;
    }

    .card-container {
        padding-right: 1rem;
        overflow-y: scroll;
    }

    .card-container .wrapper{
        box-sizing: border-box;
        display:flex;
        justify-content: flex-end;
        width: 100%;
        padding: 1rem 2rem;
        overflow-x: none;
        border: 1px solid $color-black;
        box-shadow: 0 0 0 $color-black;
        transition: box-shadow .25s ease, background-color .1s ease;

        &.active,
        &:active,
        &:hover{
            cursor: pointer;
            background-color: rgba($color-red, .05);
        }

        &.active,
        &:active {
            border: 4px solid $color-red;
            box-shadow: inset 4px 0;
        }

        &:hover{
            background-color: rgba($color-black, .1);
            box-shadow: 2px 2px;
        }
    }

    .customer .name,
    .customer .contact{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .customer .contact{
        box-sizing: border-box;
        justify-content: space-between;
        font-weight: 100;
        color: $color-gray-62;
    }

    .button-container{
        position: sticky;
        bottom: 0;
        z-index: 5;
        display: flex;
        justify-content: center;
        padding: 1rem 2rem;
        background: $color-white;
        border-top: 3px solid $color-red;
    }
}
</style>